import { Alert, Button } from "antd";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

const AndroidAlert = () => {
  const { t } = useTranslation();
  const [androidView, setAndroidView] = useState(false);
  const isTwa = localStorage.getItem("isTwa");
  const confirmAppInsstalled = sessionStorage.getItem("confirm-app-insstalled");
  const isShowInstallApp = confirmAppInsstalled !== "false";

  const handleCloseAlert = () => {
    setAndroidView(false);
    sessionStorage.setItem("confirm-app-insstalled", "false");
  };

  useEffect(() => {
    const isPwa = window.matchMedia("(display-mode: standalone)").matches;
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const windowSize = window.innerWidth > 638;
    if (isTwa || navigator.standalone || isPwa) return;

    if (isAndroid && !windowSize) {
      setAndroidView(true);
    }
  }, []);

  return (
    isShowInstallApp &&
    androidView && (
      <Alert
        afterClose={() => handleCloseAlert()}
        className=" ltr mx-5 caption-12px-medium"
        closable
        icon={
          <Button
            className="primary-button-small-with-icon"
            icon={
              <img
                src={
                  "https://cdn.firouzeh.com/public/icon-cafe-doawnload-notif.svg"
                }
                alt="bazar"
              />
            }
            onClick={() =>
              window.open("https://cafebazaar.ir/app/com.firouzeh.app")
            }
          >
            {t("download")}
          </Button>
        }
        message="دریافت اپلیکیشن فیروزه از طریق کافه بازار"
        showIcon
      />
    )
  );
};

export default AndroidAlert;
